import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useAppStore } from "../../store";

export function Footer() {
  const { assessment } = useAppStore();

  const lastEdited = assessment.lastEdited
    ? new Date(assessment.lastEdited).toLocaleString()
    : "Never";

  return (
    <Box
      component="footer"
      sx={{
        py: 1,
        px: 3,
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography variant="caption" color="text.secondary">
        ProfitStacks Framework v{assessment.appVersion}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Last saved: {lastEdited}
      </Typography>
    </Box>
  );
}
